// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__4WM8S","loaderinner":"style_loaderinner__K8ANi"};